import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Production/preview builds keep the PWA. Local development deliberately
// unregisters workers and clears only ConfirmPH-namespaced caches on the
// current origin. This prevents a stale dev worker from masking fresh code;
// the fixed :3101 origin also prevents crossover with other local apps.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    if (process.env.NODE_ENV === "development") {
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
        .catch(() => {});
      if ("caches" in window) {
        window.caches.keys()
          .then((keys) => Promise.all(keys.filter((key) => key.startsWith("confirmph-")).map((key) => window.caches.delete(key))))
          .catch(() => {});
      }
    } else {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.warn("[ConfirmPH] Service worker registration failed:", err);
        });
    }
  });
}
